import { connect } from 'react-redux';
import { showInactiveBanner } from 'common/ducks/user';
import PwdResetRequest from 'login/components/password_reset_request';

export default connect(() => ({}), { showInactiveBanner })(PwdResetRequest);
